import type { ParticipantReaction } from "@client/types/meet.types";
import type { TrackReferenceOrPlaceholder } from "@livekit/components-react";

export function getHandRaiseQueuePosition(
  participantSid: string,
  participantReactions?: Map<string, ParticipantReaction>
): number | null {
  if (!participantReactions) return null;
  const raised = [...participantReactions.entries()]
    .filter(([, reaction]) => reaction.isHandRaised)
    .sort((a, b) => (a[1].handRaisedAt ?? 0) - (b[1].handRaisedAt ?? 0));

  const index = raised.findIndex(([sid]) => sid === participantSid);
  return index >= 0 ? index + 1 : null;
}

/** Raised hands first (FIFO), then everyone else in original order. */
export function sortCameraTracksByRaisedHand(
  tracks: TrackReferenceOrPlaceholder[],
  participantReactions?: Map<string, ParticipantReaction>
): TrackReferenceOrPlaceholder[] {
  if (!participantReactions?.size) return tracks;

  const originalIndex = new Map(tracks.map((track, index) => [track.participant.sid, index]));

  return [...tracks].sort((a, b) => {
    const aReaction = participantReactions.get(a.participant.sid);
    const bReaction = participantReactions.get(b.participant.sid);
    const aRaised = Boolean(aReaction?.isHandRaised);
    const bRaised = Boolean(bReaction?.isHandRaised);

    if (aRaised && !bRaised) return -1;
    if (!aRaised && bRaised) return 1;
    if (aRaised && bRaised) {
      return (aReaction?.handRaisedAt ?? 0) - (bReaction?.handRaisedAt ?? 0);
    }
    return (originalIndex.get(a.participant.sid) ?? 0) - (originalIndex.get(b.participant.sid) ?? 0);
  });
}
